import {
  GetResultList,
  getResultList,
  deleteList,
  DeleteList,
  getBizAreaList,
  stopTask,
  retestTask,
  deleteTask,
  getTaskExecList,
  getTaskList,
  getTaskDetail,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  ChangeJobStatus,
  changeJobStatus,
  changeJobPause,
  changeJobStart,
  getGroupList,
  getSecurityDeviceList,
  getSecurityTarget,
  getTaskDetailTemplateList,
  getTaskDetailCaseList,
  getTaskDetailCaseAttackType,
  getCaseDetail,
} from '@/api/container-security/list'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取任务列表
interface GetResultListProps {
  getResultListParams: GetResultList
}
export const useGetResultList = (props: GetResultListProps) => {
  const { getResultListParams } = props
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getResultList(getResultListParams), {
    refreshDeps: [getResultListParams],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, data?.data, loading] as const
}

// 删除子任务
export const useDeleteTaskExec = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除子任务失败'))
    },
  })

  return [run, loading] as const
}

//获取安全域
export const useGetBizAreaList = () => {
  const { runAsync: run, data } = useRequest(() => getBizAreaList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域失败'))
    },
  })
  return [data?.data?.items || [], run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务停止失败'))
    },
  })
  return [run] as const
}

// 任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => retestTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务复测失败'))
    },
  })
  return [run, loading] as const
}

// 删除主任务
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest(data => deleteTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除主任务失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务执行列表
export const useGetTaskExecList = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, params: any) => getTaskExecList(id, params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取任务执行列表失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest((params: any) => getTaskList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run, loading } = useRequest((id: string) => getTaskDetail(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run] as const
}

// 暂停/重启计划任务
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '暂停/重启计划任务')
    },
  })

  return [run] as const
}

// 暂停计划任务
export const useChangeJobPause = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobPause(params), {
    manual: true,
    onError(err: any) {},
  })

  return [run] as const
}

// 开启计划任务
export const useChangeJobStart = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStart(params), {
    manual: true,
    onError(err: any) {},
  })
  return [run] as const
}

// 获取分组列表
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest(() => getGroupList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取分组列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 获取安全设备列表
export const useGetSecurityDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 获取目标主体
export const useGetSecurityTarget = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityTarget(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取目标主体失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 获取任务详情模板列表
export const useGetTaskDetailTemplateList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情模板列表失败'))
    },
  })
  return [run, loading] as const
}

// 用例列表
export const useGetTaskDetailCaseList = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(params => getTaskDetailCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例列表失败'))
    },
  })
  return [run, data?.data || [], loading] as const
}

// attck类型列表
export const useGetTaskDetailCaseAttackType = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailCaseAttackType(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取attck类型列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 获取用例详情
export const useGetCaseDetail = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(params => getCaseDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例详情失败'))
    },
  })
  return [run, data?.data || [], loading] as const
}
